import { Color } from 'common/types/Color';

export const toRgb = ([r, g, b]: Color) => `rgb(${r},${g},${b})`;
